import { Component } from "react";
import { FixedSizeList as List } from "react-window";
import classNames from "classnames";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { store } from "common/store";

import { ButtonSwitch } from "common/components/buttons";

import { FilterItem } from "./FilterItem";
import { TypeAheadInput } from "./TypeAhead";
import { renderTokenIndicator } from "./FilterBarUtils";
import "./AllFilters.scss";

export class AllFilters extends Component {
    static defaultProps = {
        allowExclude: true,
        height: 0,
        readOnlyDimensions: new Set(),
        isOmit: false
    };

    constructor(props) {
        super(props);
        const BUTree = store.getState().common.merchant_config.business_units;
        this.state = {
            mode: "quick",
            selectedFilters: [],
            // eslint-disable-next-line sentence-case/sentence-case
            buTree: BUTree?.filter((bu) => bu.display_name !== "Unmapped MIDs")
        };
    }
    
    getTypeAhead = () => {
        const level = this.state.selectedFilters.length - 1;
        const filterItem = this.state.selectedFilters[level];
        const searchResults = (lvl) => (results) => {
            this.setState((prevState, props) => {
                const updatedFilters = [...prevState.selectedFilters];
                if (results.raw.length) {
                    updatedFilters[lvl].items = results.raw;
                } else if (results.value === "") {
                    updatedFilters[lvl].items = filterItem.originalItems;
                } else {
                    updatedFilters[lvl].items = [{
                        alias: "No results...",
                        id: "data_noresult"
                    }];
                }
                return { selectedFilters: updatedFilters, isOmit: results.isOmit };
            });
        };
    
        if (filterItem?.items) {
            return (<TypeAheadInput key={`typeahead_lvl_${level}_${filterItem?.pivot}`} srcData={filterItem.items} onTypeAhead={searchResults(level)} selectedCategories={this.props.selectedCategories} onePerCategory={false} focusOnMount={false}/>);
        }
        return null;
    };
    
    mainListItemClick = (pivot, operators) => (e) => {
        e.stopPropagation();
        const filterItems = pivot === "bu" ? this.mapTreeToFlatList(this.state.buTree) : this.props.allData[pivot];
        const selectedFilter = {
            pivot,
            originalItems: [...filterItems],
            items: filterItems,
            operators
        };
        this.setState({ selectedFilters: [selectedFilter] });
    };
    
    mapTreeToFlatList = (buList) => {
        if (!buList.length) {
            return this.props.allData.bu;
        }
        const merged = buList.map((bu) => ({ ...bu, ...this.props.allData.bu.find((b) => b.ref === bu.id) }));
        return merged.sort((a, b) => (a.alias > b.alias ? 1 : -1));
    };
    
    filterItemDrill = (item, level) => {
        const nextLevel = this.mapTreeToFlatList(item.children);
        this.setState(
            (prevState, props) => {
                const nextList = {
                    pivot: item.pivot,
                    originalItems: [...nextLevel],
                    items: nextLevel
                };
                const currentListItems = prevState.selectedFilters[level - 1].items.map((f) => ({ ...f, selected: f.id === item.id }));
                const currentList = {
                    pivot: item.pivot,
                    originalItems: [...currentListItems],
                    items: currentListItems
                };
                return {
                    selectedFilters: [...prevState.selectedFilters.slice(0, level - 1), currentList, nextList]
                };
            },
            () => {
                setTimeout(() => {
                    document.querySelector(".selected-category").scrollLeft += 450;
                }, 100);
            }
        );
    };
    
    createMainList() {
        const newList = Object.keys(this.props.allData).filter((k) => !this.props.readOnlyDimensions.has(k)).map((pivot) => {
            if (!this.props.allData[pivot].length) return;
            const alias = this.props.allData[pivot][0].pivot_alias;
            const operators = this.props.selectedCategories.find((c) => c.category === pivot)?.operators || [];
            const selectedPivot = this.state.selectedFilters[0]?.pivot;
            return {
                display: alias, pivot, operators, selected: pivot === selectedPivot
            };
        });
        return newList.filter(Boolean).sort((a, b) => (a.display > b.display ? 1 : -1));
    }
    
    renderSelectedFilters(resultsHeight) {
        const sendFilterAction = (action, item) => {
            this.props.onFilterItemClick(action, item, this.state.mode === "multi");
        };
        
        // eslint-disable-next-line react/function-component-definition
        const listResults = (filterList, level, selectedItems, operators) => ({
            key, index, style
        }) => (
            <FilterItem
                key={`sublist1_${key}`}
                style={style}
                isOmit={this.state.isOmit}
                item={filterList[index]}
                index={index}
                level={level}
                filterItemDrill={this.filterItemDrill}
                filterItemClick={sendFilterAction}
                allowExclude
                showCategory={false}
                operators={operators}
                previouslySelected={selectedItems.includes(filterList[index].id)}
            />
        );
        
        if (this.state.selectedFilters.length) {
            return this.state.selectedFilters.map((f, index) => {
                const selectedItems = this.props.getAllSelectedIdsInCategory(f.pivot);
                return (
                    <div className="list" key={`list_${f.items[0].id}`}>
                        <List
                            height={resultsHeight}
                            itemCount={f.items.length}
                            itemSize={30}
                            width={450}
                        >
                            {listResults(f.items, index + 1, selectedItems, f.operators)}
                        </List>
                    </div>
                );
            });
        }
        return null;
    }
    
    render() {
        const resultsHeight = this.props.height - 80;
        const mainList = this.createMainList();
        if (this.props.open) {
            // eslint-disable-next-line react/function-component-definition
            const mainListRendererResults = (resultsList) => ({
                key, index, style
            }) => (
                <div key={key} style={style} className={classNames("mainlist-row", { selected: resultsList[index].selected })} onClick={this.mainListItemClick(resultsList[index].pivot, mainList[index].operators)}>
                    <div className="has-tokens">{renderTokenIndicator(mainList[index].operators)}</div>
                    <div className="lbl">{resultsList[index].display}</div>
                    <div className="angle"><FontAwesomeIcon icon={faAngleRight} /></div>
                </div>
            );
    
            const setMode = (mode) => () => {
                this.setState({ mode });
            };
            
            return (
                <div className="all-filters2">
                    <div className="toolbar">
                        <div className="header">
                            <div className="btn-group">
                                <ButtonSwitch
                                    activeValue={this.state.mode}
                                    className="mode-switch"
                                >
                                    <ButtonSwitch.Button value="quick" onClick={setMode("quick")}>Quick add</ButtonSwitch.Button>
                                    <ButtonSwitch.Button value="multi" onClick={setMode("multi")}>Multi-select</ButtonSwitch.Button>
                                </ButtonSwitch>
                            </div>
                        </div>
                        <div className="search">
                            {this.getTypeAhead()}
                        </div>
                    </div>
                    <div className="all-lists">
                        <div className="main-list">
                            <List
                                height={resultsHeight}
                                width={330}
                                itemCount={mainList.length}
                                itemSize={30}
                            >
                                {mainListRendererResults(mainList)}
                            </List>
                        </div>
                        <div className="selected-category" style={{ height: resultsHeight }}>
                            {this.renderSelectedFilters(resultsHeight)}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }
}
